<template>
  <span class="lxm-tag tag" :style="{ backgroundColor: color }" @click="clicked">{{ text }}</span>
</template>

<style lang="stylus" scoped>
  @import '../../styles/variables.styl'
  .lxm-tag
    &.tag
      padding: 0 siz(8)
      height: siz(19)
      line-height: 1
      background-color: cloudy
      color: white
      font-size: size-small
</style>

<script>
  import * as mTypes from '../../../store/mutation-types'
  export default {
    props: {
      color: String,
      text: String,
      to: Object
    },
    methods: {
      clicked () {
        if (this.to) {
          this.$store.commit(mTypes.TRANSITION_SET_BACK)
          this.$router.push(this.to)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LxmTag.vue?375ee149